import type { SprintEntity } from '@data/utils/types';
import { fetchProductReports } from '@data/api/products';
import * as queryKeys from '@data/constants/keys';

import { sprintSpan } from './sprintReports';

/** One read of a product's entries over the sprints on screen, shared by every card that prices them. */
export const productReportsQuery = (
  productId: string,
  sprints: SprintEntity[],
  queue: <T>(read: () => Promise<T>) => Promise<T>,
) => {
  const span = sprintSpan(sprints);
  return {
    queryKey: [queryKeys.PRODUCT_REPORTS, productId, span],
    queryFn: () => queue(() => fetchProductReports(productId, span?.from ?? '', span?.to ?? '')),
    enabled: !!span,
    staleTime: 60_000,
  };
};
